module.exports = __webpack_public_path__ + "static/media/szlogo_also.adc62b07.jpg";